import React, { Component } from "react";
import { Trans, withTranslation } from "react-i18next";
import ZainGamezoneCatchPageDisplay from "./ZainGamezoneCatchPage.styled";
import axios from "axios";
import { setLoginData } from "../../helpers/helpers";
import queryString from "query-string";
import * as localLang from "../../i18n/i18n";




class ZainGamezoneCatchPage extends Component {
  constructor() {
    super();

  }
  async componentDidMount() {
    this.fireAPI();

  }

  fireAPI = async () => {

    //yousry lang
    const data = queryString.parse(window.location.search)
   //console.log(data)
    if (data.lang) {
     //console.log("lang");
      localStorage.setItem("i18nextLng", data.lang);
      localLang.checklocalLanguage();
    }
    if (data.msisdn) {
      const res = await axios.get(`http://www.api.playit.mobi/api/v1/getToken/${data.msisdn}/1`)
        .then(res => {
          setLoginData(res.data.user_id, res.data.token, res.data.user_name, res.data.photo, res.data.operator_id, res.data.user_email, res.data.msisdn);
          window.location.href = "/";
        }).catch(error => {
         //console.log(error);
          window.location.href = "/";
        }
        )
    } else {
      window.location.href = "/";
    }
  }

  render() {

    return (
      <ZainGamezoneCatchPageDisplay className="">
        <div>
          <p>Gamezone</p>
        </div>

      </ZainGamezoneCatchPageDisplay>
    );
  }
}
export default withTranslation()(ZainGamezoneCatchPage);
